import { useEffect } from "react";

const eventName = "click";
const rootId = "EnterpriseManagementNavBar";

const useShadowToggle = (id: string, isOpen: boolean, isProcess: boolean | undefined) => {      
    
    const root = document.getElementById(rootId)!;

    useEffect(() => {
        if(isProcess) {
            const handleClick: any = (ev: PointerEvent) => {
                if (ev.target == root) {
                    if(isOpen && ev.composedPath().find((el) => { return (el as HTMLElement).id == id })) {
                    ev.stopImmediatePropagation();
                    }
                }
            }
     
            document.addEventListener(eventName, handleClick, true);
    
            return () => {
                document.removeEventListener(eventName, handleClick, true);
            }
        }
    }, [isOpen]); 
}

export default useShadowToggle;